/**
 * Created by lvsen05191@hellobike.com on 2019/8/26 at 11:20.
 */
export const dataURLtoFile = (dataUrl: string): Blob => {
  const arr = dataUrl.split(",");
  const mime = (arr[0].match(/:(.*?);/) || [])[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
};
